import { Injectable } from '@angular/core'
import { ModalPositionService } from '@helios/user-preferences'
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap'
import {
  Break,
  BreakCodeResponse,
  BreakResponseObject,
  resolveBreakCodes,
} from '../../model/break.model'
import { HoldModalComponent } from './hold-modal.component'

@Injectable({
  providedIn: 'root',
})
export class HoldModalService {
  private holdForDays = 1
  private readonly holdTillDate = new Date()
  private holdTillDaysOrDate: 'days' | 'date' = 'days'

  constructor(
    private readonly modalService: NgbModal,
    private readonly modalPositionService: ModalPositionService,
  ) {}

  toggleHoldModal(
    breaks: Break[],
    days?: number,
    breakCodes?: BreakCodeResponse,
  ): Promise<BreakResponseObject> {
    const compKey = 'hold-breaks'
    const uniqueId = compKey + '-' + Date.now()
    const modalRef = this.modalService.open(HoldModalComponent, {
      size: 'lg',
      windowClass: `modal-window-click-through ${uniqueId}`,
      keyboard: false,
      beforeDismiss: () => {
        return this.modalPositionService.handleModalPositionSaveOnDismiss(
          uniqueId,
          compKey,
        )
      },
    } as NgbModalOptions)
    const component = modalRef.componentInstance as HoldModalComponent

    if (days != null) {
      this.holdForDays = days
      this.holdTillDaysOrDate = 'days'
    }
    component.breaks = breaks
    component.days = this.holdForDays
    component.daysOrDate = this.holdTillDaysOrDate
    component.date = this.holdTillDate
    component.availability = resolveBreakCodes(breaks, breakCodes)

    this.modalPositionService.handleModalPositionSetup(uniqueId, compKey)

    return modalRef.result.then(result => {
      this.holdForDays
      this.holdTillDaysOrDate
      this.holdTillDate
      return result
    })
  }
}
